// extracted by mini-css-extract-plugin
export default {"dotMainWrapper":"dot_dotMainWrapper__PuaGb","dot":"dot_dot__H5s26","label":"dot_label__XV0vs"};